module.exports = __webpack_public_path__ + "static/media/play.c9d34cd3.svg";